import resourcesService from '../../services/resourcesService'

class ResourcesController { 
  fetchResources = resourcesService.fetchResources
  fetchResource = resourcesService.fetchResource
}

export default new ResourcesController



// WEBPACK FOOTER //
// ../src/controllers/resourcesController/resourcesController.js